module.exports = __webpack_public_path__ + "img/olga.c6d789f.webp";